import { graphql } from 'react-relay';
export type { ethereumWalletStatusQuery as ethereumWalletStatusQueryType } from './__generated__/ethereumWalletStatusQuery.graphql';

export const ethereumWalletStatusQuery = graphql`
    query ethereumWalletStatusQuery($userId: String!, $fetchUser: Boolean!) {
        viewer {
            nftMintBlog: featureFlag(feature: "nftMintBlog")
            nftBenignNeglect: featureFlag(feature: "nftBenignNeglect")
            user(userId: $userId) @include(if: $fetchUser) {
                ...ConnectedWalletStatus_user
            }
            ...WithWalletConnectionEnsured_viewer
            ...usePersistedWalletAddress_viewer @arguments(fetchUser: $fetchUser, userId: $userId)
        }
    }
`;
